// @ts-nocheck
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/Subscribe";
import { subscribe } from "@store/Framework/Services/SubscribeService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, SendDataToApi, async props => {
    await subscribe(props.apiParameter);
});
